import { Dashboard } from "@mui/icons-material";
import { routespath } from "./routespath";

export const successArchievedMessage = {
  label: "archieved",
  value: "Project Archieved Successfully!!",
};

export const successDeletedMessage = {
  label: "deleted",
  value: "Project Deleted Successfully!!",
};
export const required = {
  label: "requiredMessage",
  value: "This field is required!",
};
export const fileUploadModalText = {
  uploadFailed: "File Uploaded Failed",
  uploadSuccessfull: "File Uploaded successfully",
  dataValidationInsightsGeneration: "Data validation and insights generation",
  mergedFileInProgress: "Merge file is in progress, Please wait!!",
  mergedFileSuccessFull: "Merge file has been generated successfully.",
  failedToMergeFile: "Failed to merge file.",
  disclaimerNote: "Don't close the pop-up or refresh the window, as it will terminate the process and result in data loss.",
  uploadCorrectFiles: "Upload the correct files",
};
export const confirmationArchieveTitle = "Sure you want to Archive?";
export const confirmationArchievedDescription = "The project will be archived.";
export const confirmationDeletedDescription = "The project will be deleted. You won't be able to access it.";
export const confirmationDeleteTitle = "Sure you want to Delete?";

// Login Page Constant
export const LoginPageText =
  "specializes in AI-driven solutions for the life sciences sector, offering an advanced platform that analyzes complex medical data. Their focus is on providing actionable insights to medical affairs, regulatory affairs, and safety teams, ultimately aiming to improve patient care and outcomes.";
export const CardContainerHead = "Our Solutions";

export const ROUTES = {
  HOME_PAGE: "/",
};

export const PROJECT_TYPE = {
  PROJECT: "PROJECT",
  ARCHIVED: "ARCHIVED",
};

export const SNACKBAR_TYPES = {
  SUCCESS: "success",
  ERROR: "error",
  WARNING: "warning",
};

export const INSIGHTCARD = [
  {
    name: "MVOC Insights",
    details: "Transform unstructured medical voice of customer data into structured, actionable insights by analyzing conversations from advisory boards, medical congresses, and healthcare professional (HCP) interactions.",
  },
  {
    name: "Social Media Analysis",
    details: "Analyze unstructured social media content from platforms such as X (formerly Twitter) and LinkedIn to uncover stakeholder sentiment, engagement patterns, and emerging trends relevant to pharmaceutical strategy.",
  },
  {
    name: "Digital Source",
    details: "Detect early clinical and competitive signals by extracting insights from unstructured content across pharma-relevant digital platforms, including scientific blogs, news media, and regulatory publications.",
  },
  // {
  //   name: "SLR",
  //   details: "An AI-powered tool designed to automate and optimize the title and abstract screening phase in Systematic Literature Reviews (SLRs), enhancing speed, accuracy, and efficiency while significantly reducing human-intensive effort.",
  // },
]


export const projectErrorMessages = {
  PROJECT_NAME_REQUIRED_ERROR_MESSAGE: "Please fill out Project Name field.",
  PROJECT_NAME_MANDATORY_ERROR_MESSAGE: "Please fill out Project Name field",
  PROJECT_CLIENT_NAME_MANDATORY_ERROR_MESSAGE: "Please fill out Client Name field.",
}
export const projectIdInStepper = "project_id";
export const excludeKeysForText = ["<", ">", "/", "?", "!"];
export const createProjectHeading = {
  PROJECT_DETAILS: "Project Details",
  SELECT_INSIGHT: "Select Insight",
  MVOC_INSIGHT: "MVOC Insights",
};
export const uploadfileComponentDetails = {
  MVOCDATAFILE: "Upload Voice of Customer(MVOC) data file",
  SIMAPPINGFILE: "Upload the themes to Strategic Imperatives(SI) Mapping",
  MVOCFILEFORMATE: "MVOC file should have at least one column with header “conversation_column”.",
  SIMAPPINGFILEFORMATE: "SI mapping file should have exactly two columns with headers “Primary_Themes” and “SI”.",
  MVOCRESTRICITION: "Please restrict your input under 100 rows.",
  SIRESTRICITION: "Please refrain from making alterations to the “Primary_Themes” column in template file.",
}
export const INSIGHT_type = {
  MVOC: 'MVOC',
  SOCIAL_MEDIA: 'SOCIAL_MEDIA',
  DIGITAL_SOURCE: 'DIGITAL_SOURCE',
  PLS: 'PLS'
}
export const CHUNK_SIZE = 1 * 1024 * 1024;

export const HORIZONTAL_TABS = {
  Dashboard_VIEW: "MVOC View",
  TABULAR_VIEW: "Tabular View",
  LONGITUDINAL_VIEW: "Longitudinal View",
  SOCIAL_MEDIA_ANALYSIS_VIEW: "Social Media Analysis View"

}

export const ERROR_MESSAGES = {
  MVOC_METADATA_ERROR: "Failed to save Wave and Prompt names.",
  FIELD_REQUIRED: "Please fill all required fields",
}

export const PROMPT_MODAL_TABS = {
  OVERVIEW: "Overview",
  PRIMARY_THEMES: "Primary Themes",
  OUTPUT_INSTRUCTIONS: "Output and instructions"
};

export const PROMPT_MODAL_LABELS = [
  PROMPT_MODAL_TABS.OVERVIEW,
  PROMPT_MODAL_TABS.PRIMARY_THEMES,
  PROMPT_MODAL_TABS.OUTPUT_INSTRUCTIONS
];
export const LONGITUDINAL_VIEW_TEXT = {
  PROJECT_DETAILS: "Project Details",
  PROMPT_NAME: "Prompt Name",
  WAVE_SELECTOR: "Wave Selector",
  APPLY_SELECTIONS: "Apply Selections",
  EMPTY_STATE_TEXT: "Your graph is waiting to take shape! 🎯",
  EMPTY_STATE_DESCRIPTION: "Start by selecting output files from Waves and apply them to view the graph.",
}

export const PROMPT_ID = "69778813-72a0-400d-aeb3-d6ef8c5c42e4";

//Functions>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>
export const hasSpecialCharactersWithRegex = (input) => {
  // Define a regular expression pattern to match special characters, excluding '-' and '_'
  const regex = /[!@#$%^&*()+=\[\]{};'"\\|,<>\/?~_-]/;
  const multipleSpaces = /\s{2,}/; // Matches 2 or more consecutive spaces


  // Test if the input string matches the regex pattern
  return regex.test(input) || multipleSpaces.test(input);
};
export const preventUserToAddSymbol = (evt) => {
  if ((hasSpecialCharactersWithRegex(evt?.key))) {
    evt.preventDefault();
  }
};
export const checkDataisObject = (data) => {
  return typeof data === 'object' && data !== null
}
export const getRouteId = (route) => {
  if (route == routespath[0].createProjectDetails) {
    return null;
  }
  return route?.split('/')[route?.split('/')?.length - 1]
}
// Helper function to adjust color opacity/lightness with more distinction
export const adjustColorOpacity = (hexColor, index, totalThemes) => {
  const r = parseInt(hexColor.slice(1, 3), 16);
  const g = parseInt(hexColor.slice(3, 5), 16);
  const b = parseInt(hexColor.slice(5, 7), 16);

  // Create more distinct steps between shades
  const step = 1 / (totalThemes + 1);
  const opacity = 1 - (index * step);

  // Adjust the color while maintaining more saturation
  const adjustedR = Math.round(r * opacity);
  const adjustedG = Math.round(g * opacity);
  const adjustedB = Math.round(b * opacity);

  return `#${adjustedR.toString(16).padStart(2, '0')}${adjustedG.toString(16).padStart(2, '0')}${adjustedB.toString(16).padStart(2, '0')}`;
};


export const constructCustomLegends = (waveThemeMapping, themeColorMapping) => {
// Construct custom_legends using the generated mappings
  const custom_legends = {};
  console.log(waveThemeMapping, themeColorMapping, "waveThemeMapping, themeColorMapping");
  for (const [wave, initiatives] of Object.entries(waveThemeMapping)) {
      custom_legends[wave] = {};
      for (const [initiative, themes] of Object.entries(initiatives)) {
          custom_legends[wave][initiative] = themes.map(theme => ({
              theme,
              color: themeColorMapping[`${wave}_${theme}`]  // Default to black if no color found
          }));
      }
  }
  return custom_legends;
}
export const baseColors = [
    '#1995A4',
    '#F5498E',  
    '#F549F5',  
    '#9BF3DB',  
    '#FFF9E6',  
    '#AB77CF',  
    '#B59110', 
    '#F46300',  
    '#630163',  
    '#000DFF',  
    '#7DF549',  
    '#FCB12E',
    '#926A57', 
    '#AC0050', 
    '#41447B',  
    '#00FFDE', 
    '#2D46B7',
    '#5E6275',
    '#16561E',
    '#5570A3',
    '#7949F0',
    '#A3398A',
    '#49C4F5CC',
];






